import { baseUrl, handleResponse, handleError, GetHeaders, PostOptions, PutOptions, DeleteHeaders } from "../common/ApiUtils";

const apiUrl = baseUrl + "HourUtilizationRequest";

export function cancelHourUtilizationRequest(requestId) {
  return fetch(apiUrl + "/delete/" + requestId, DeleteHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function acceptHourUtilizationRequest(requestId, paidDate) {
  return fetch(apiUrl + "/confirm/" + requestId, PostOptions({ PaidDate: paidDate }))
    .then(handleResponse)
    .catch(handleError);
}

export function getHourUtilizationRequests(isAdmin = false, userId = null) {
  if (isAdmin && userId) {
    return fetch(apiUrl + "?consultantId=" + userId, GetHeaders())
      .then(handleResponse)
      .catch(handleError);
  }
  return fetch(apiUrl, GetHeaders()).then(handleResponse).catch(handleError);
}

export function requestHourUtilization(request, isAdmin = false, userId = null) {
  if (isAdmin && userId) {
    return fetch(apiUrl + "?consultantId=" + userId, PostOptions(request))
      .then(handleResponse)
      .catch(handleError);
  }
  return fetch(apiUrl, PostOptions(request)).then(handleResponse).catch(handleError);
}

export function updateHourUtilizationRequest(requestId, updatedRequest) {
  return fetch(apiUrl + requestId, PutOptions(JSON.stringify(updatedRequest)))
    .then(handleResponse)
    .catch(handleError);
}

export function getRoundedRateAgnosticDollars(valueToRound, consultantId = null) {
  return fetch(
    `${apiUrl}/rateAgnostic?requestValue=${valueToRound}${consultantId ? `&consultantId=${consultantId}` : ""}`,
    GetHeaders()
  )
    .then(handleResponse)
    .catch(handleError);
}

export function requestRateAgnosticHourUtilization(request, consultantId = null) {
  return fetch(`${apiUrl}/rateAgnostic${consultantId ? `?consultantId=${consultantId}` : ""}`, PostOptions(request))
    .then(handleResponse)
    .catch(handleError);
}

export function addDatePaid(requestId, request) {
  return fetch(`${apiUrl}/${requestId}/datePaid`, PostOptions(request)).then(handleResponse).catch(handleError);
}
